import classNames from "classnames";
import { useRef, useState } from "react";
import { Button } from "reactstrap";
import { Popover, Tooltip, Whisper } from "rsuite";

// isLast = index !== values?.length - 1

const MultipleTextOption = ({
  isLast,
  isPrimary,
  title,
  type,
  color,
  label,
  onOpen,
  onClose,
  options,
  icon,
  custom,
  copy = undefined,
}) => {
  const whisperOptionsRef = useRef();
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    {
      navigator.clipboard.writeText(copy);
      setCopied(true);

      setTimeout(() => {
        setCopied(false);
      }, 1500);
    }
  };

  return (
    <div
      className={classNames(
        "p-2 d-flex align-items-center justify-content-between",
        {
          "border-bottom border-superlight": isLast,
        }
      )}
    >
      <div className="pr-0 text-truncate d-flex align-items-center">
        {isPrimary && (
          <Whisper
            trigger="hover"
            placement="autoVertical"
            delayOpen={400}
            speaker={<Tooltip>Primary {type}</Tooltip>}
          >
            <i
              className="mdi mdi-star-circle"
              style={{
                fontSize: "20px",
                color: "#F2C33E",
                lineHeight: 1,
              }}
            ></i>
          </Whisper>
        )}
        {color && (
          <Whisper
            trigger="hover"
            placement="autoVertical"
            delayOpen={400}
            speaker={<Tooltip>{label}</Tooltip>}
          >
            <i
              className="mdi mdi-checkbox-blank-circle"
              style={{
                fontSize: "20px",
                color: color,
                lineHeight: 1,
              }}
            ></i>
          </Whisper>
        )}
        {icon && (
          <i
            className={`mdi mdi-${icon}`}
            style={{ fontSize: 20, lineHeight: 1 }}
          ></i>
        )}
        {custom && custom}
        <h5
          className="m-0 font-weight-normal text-truncate d-inline pl-1"
          style={{
            lineHeight: 1.3,
            position: "relative",
            flexGrow: 1,
          }}
        >
          {title}
        </h5>
      </div>
      <div className="d-flex">
        {copy && (
          <Button
            size="sm"
            outline
            className="btn-icon-only mr-0"
            color="primary"
            style={{
              height: "1.5rem",
              width: "1.5rem",
              marginLeft: ".6rem",
            }}
            onClick={handleCopy}
          >
            <i
              className={copied ? "mdi mdi-check" : `mdi mdi-content-copy`}
            ></i>
          </Button>
        )}
        <Whisper
          placement="autoVerticalEnd"
          trigger="click"
          onOpen={onOpen}
          onClose={onClose}
          ref={whisperOptionsRef}
          speaker={
            <Popover className="sidebar-popover" full>
              {options(whisperOptionsRef)}
            </Popover>
          }
          controlId="newRecordDropdown"
        >
          <Button
            size="sm"
            outline
            className="btn-icon-only"
            style={{
              height: "1.5rem",
              width: "1.5rem",
            }}
          >
            <i
              className={`mdi mdi-dots-horizontal`}
              style={{
                fontSize: 20,
                lineHeight: 1,
                position: "relative",
                top: 1,
              }}
            ></i>
          </Button>
        </Whisper>
      </div>
    </div>
  );
};

export default MultipleTextOption;
